import _ from 'lodash'
import { ItList } from 'types/graphql'

import { LOCAL_STORAGE_VIEW_KEY } from 'src/lib/constants'

export type LocalView = Pick<
  ItList,
  'updatedAt' | 'coverUrl' | 'name' | 'relationship' | 'price' | 'creator'
> & { itListId: number }

type LocalViews = { views: LocalView[] } | null

export function getLocalViews(): LocalViews {
  const saved = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_VIEW_KEY)
  ) as LocalViews
  if (saved?.views) {
    return saved
  }
  return { views: [] }
}

export async function saveLocalView(itList: LocalView) {
  const currentState = getLocalViews()
  const newItem: LocalView = _.pick(itList, [
    'updatedAt',
    'coverUrl',
    'name',
    'relationship',
    'price',
    'creator',
    'itListId',
  ])

  localStorage.setItem(
    LOCAL_STORAGE_VIEW_KEY,
    JSON.stringify({
      views: [
        newItem,
        ...currentState.views.filter(
          (item) => item.itListId !== itList.itListId
        ),
      ].slice(0, 12),
    })
  )
}

export function resetLocalViews() {
  localStorage.removeItem(LOCAL_STORAGE_VIEW_KEY)
}
